import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Collapse from '@mui/material/Collapse';
import { green } from '@mui/material/colors';
import { VideoViewer } from './VideoViewer';
import { VitalLamp } from './VitalLamp';
import { fullNameSplit } from '../helpers';
import { DataGrid } from '@mui/x-data-grid';
import EnhancedLapTable from './EnhancedLapTable';

// 1709446560.7016225
// 1709446681.9528801

function calculateIntersectionPoint(startLine, point1, point2) {
  const x1 = startLine[0].lng;
  const y1 = startLine[0].lat;
  const x2 = startLine[1].lng;
  const y2 = startLine[1].lat;

  const x3 = point1.lng;
  const y3 = point1.lat;
  const x4 = point2.lng;
  const y4 = point2.lat;

  const determinant = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);

  if (determinant === 0) {
    // Lines are parallel, no intersection
    return null;
  } else {
    const intersectionX =
      ((x3 - x4) * (x1 * y2 - y1 * x2) - (x1 - x2) * (x3 * y4 - y3 * x4)) /
      determinant;
    const intersectionY =
      ((y3 - y4) * (x1 * y2 - y1 * x2) - (y1 - y2) * (x3 * y4 - y3 * x4)) /
      determinant;

    // Check if the intersection point falls within the range of both line segments
    if (
      isBetween(intersectionX, x1, x2) &&
      isBetween(intersectionY, y1, y2) &&
      isBetween(intersectionX, x3, x4) &&
      isBetween(intersectionY, y3, y4)
    ) {
      return { lat: intersectionY, lng: intersectionX };
    } else {
      // Intersection point is not within the range of both line segments
      return null;
    }
  }
}

// Helper function to check if a value is within a range
function isBetween(value, start, end) {
  return value >= Math.min(start, end) && value <= Math.max(start, end);
}

function LapTimeIntersect({ metric_data, startlinecoords, setLapTimeStamps }) {
  if (metric_data.length < 1) return;
  // console.log(metric_data);
  const recentmetrics = metric_data?.slice(-2);
  // console.log(recentmetrics);
  const currentLatitude = recentmetrics[1]?.metrics.LATITUDE[2];
  const currentLongitude = recentmetrics[1]?.metrics.LONGITUDE[2];
  const previousLatitude = recentmetrics[0]?.metrics.LATITUDE[2];
  const previousLongitude = recentmetrics[0]?.metrics.LONGITUDE[2];

  const latestMetric = metric_data?.slice(-1)[0]?.metrics;
  // const currentLatitude = latestMetric?.LATITUDE[2] || null;
  // const currentLongitude = latestMetric?.LONGITUDE[2] || null;
  const currentLatLng = { lng: currentLongitude, lat: currentLatitude };
  // console.log('currentLatLng', currentLatLng);

  const previousMetric = metric_data?.slice(-2)[0]?.metrics;
  // const previousLatitude = previousMetric?.LATITUDE[2] || null;
  // const previousLongitude = previousMetric?.LONGITUDE[2] || null;
  const previousLatLng = { lng: previousLongitude, lat: previousLatitude };
  // console.log('previousLatLng', previousLatLng);
  // const previousLatLng = { lat: 38.16162, lng: -122.45515 };
  // const currentLatLng = { lat: 38.16163, lng: -122.45516 };

  let intersectionPoint = null;
  if (
    currentLatitude &&
    currentLongitude &&
    previousLatitude &&
    previousLongitude
  ) {
    // console.log(
    //   currentLatitude,
    //   previousLongitude,
    //   previousLatitude,
    //   previousLongitude
    // );
    intersectionPoint = calculateIntersectionPoint(
      startlinecoords,
      previousLatLng,
      currentLatLng
    );

    if (intersectionPoint) {
      console.log(
        `Intersection point: ${intersectionPoint.lat}, ${intersectionPoint.lng}`
      );
      console.log(latestMetric?.LATITUDE[0]); //send time
      const localTime = new Date();
      const formattedTime = localTime.toLocaleTimeString();
      console.log(formattedTime);
      setLapTimeStamps((s) => [...s, latestMetric?.LATITUDE[0]]);
    } else {
      // console.log('No intersection point (lines are parallel)');
    }
  }
  return (
    <Box>
      <Typography>{intersectionPoint ? 'crossed' : 'running'}</Typography>
    </Box>
  );
}

function LapTime({ metric_data, startlinecoords, setLapTimeStamps }) {
  if (!metric_data) return;
  const latestMetric = metric_data?.slice(-1)[0]?.metrics;
  const latitude = latestMetric?.LATITUDE[2] || null;
  const longitude = latestMetric?.LONGITUDE[2] || null;
  const thing = { lng: longitude, lat: latitude };
  const result = hasCrossedStartFinishLine(thing, startlinecoords);
  if (result) {
    console.log(latestMetric?.LATITUDE[0]); //send time
    const localTime = new Date();
    const formattedTime = localTime.toLocaleTimeString();
    console.log(formattedTime);
    setLapTimeStamps((s) => [...s, latestMetric?.LATITUDE[0]]);
  }
  return (
    <Box>
      <Typography>{result ? 'crossed' : 'running'}</Typography>
    </Box>
  );
}

function Person(props) {
  return (
    <Box
      sx={{
        p: 1,
        m: 0,
        border: '3px solid',
        borderColor: green['A400'],
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: '67px',
        width: '67px',
      }}
    >
      <Avatar
        alt={`${props.memberObject.name}`}
        sx={{ mt: 0, width: '56px', height: '56px' }}
        src={props.memberObject.profileImage}
      >
        {props.memberObject.number}
      </Avatar>
      <Typography>
        {fullNameSplit(props.memberObject.name).firstName}
      </Typography>
      {/* <Typography>{props.memberObject.number}</Typography> */}
    </Box>
  );
}

function pointToLineDistance(point, startLine) {
  const lineStart = startLine[0];
  const lineEnd = startLine[1];
  const x = point.lng;
  const y = point.lat;
  const x1 = lineStart.lng;
  const y1 = lineStart.lat;
  const x2 = lineEnd.lng;
  const y2 = lineEnd.lat;

  // Calculate the squared distance from the point to the line
  const num = Math.abs((y2 - y1) * x - (x2 - x1) * y + x2 * y1 - y2 * x1);
  const denom = Math.sqrt((y2 - y1) ** 2 + (x2 - x1) ** 2);

  return num / denom;
}

function hasCrossedStartFinishLine(currentCoord, startLine) {
  const distanceToLine = pointToLineDistance(currentCoord, startLine);
  // Set a threshold based on your track width
  const threshold = 0.00003; // default 0.0001
  return distanceToLine < threshold;
}

const mockBeaconArray = [
  1709446560.7016225, 1709446681.9528801, 1709446803.9528801,
  1709446924.9528805,
];

function MemberStats({ memberObject, data, startlinecoords }) {
  const [expanded, setExpanded] = useState(false);
  const [lapTimeStamps, setLapTimeStamps] = useState([]);

  // useEffect(() => {
  //   const res = LapTimeGrid(lapTimeStamps);
  //   console.log(res);
  // }, [lapTimeStamps]);

  function secondsDifference(date1, date2) {
    const differenceInSeconds = Math.abs((date2 - date1) / 1000);
    return differenceInSeconds;
  }

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  return (
    <Paper sx={{ mb: 1 }}>
      <Box
        onClick={handleExpandClick}
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          gap: 1,
          p: 1,
          m: 1,
          bgcolor: 'background.paper',
          borderRadius: 1,
        }}
      >
        <div>here:{JSON.stringify(lapTimeStamps)}</div>
        <Person memberObject={memberObject} />
        <VitalLamp
          metric_data={data}
          metric_name="SPEED"
          desired_unit={'mph'}
          desired_unit_name={'mph'}
        />
        <VitalLamp
          metric_data={data}
          metric_name="WATER_TEMP"
          desired_unit={'F'}
          desired_unit_name={'°F'}
        />
        <VitalLamp
          metric_data={data}
          metric_name="OIL_PRESSURE"
          desired_unit={'psi'}
          desired_unit_name={'psi'}
        />
        <LapTimeIntersect
          metric_data={data}
          startlinecoords={startlinecoords}
          setLapTimeStamps={setLapTimeStamps}
        />
      </Box>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            gap: 1,
            p: 1,
            m: 1,
            bgcolor: 'background.paper',
            borderRadius: 1,
          }}
        >
          <VitalLamp
            metric_data={data}
            metric_name="BATTERY"
            desired_unit={'volts'}
            desired_unit_name={'volts'}
          />
        </Box>
        <EnhancedLapTable beacon_array={mockBeaconArray} />
        {memberObject.video_url && (
          <VideoViewer video_url={memberObject.video_url} />
        )}
      </Collapse>
    </Paper>
  );
}
export default MemberStats;
